import React, { useState, useEffect } from "react";
import Intro from "../components/Intro";
import Results from "./../components/Results";
import { useSelector } from "react-redux";

import { Helmet } from "react-helmet";
import axios from "axios";
import { apiUrl, API_BASE_URL } from "../utils/urls";

function Home() {
  const [result, setResult] = useState(null);
  const [search, setSearch] = useState("");
  const [instaResults, setInstaResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetch, setIsFetch] = useState(false);
  const [postLimit, setPostLimit] = useState(20);

  const { user } = useSelector((state) => state.user);

  // getSearch
  const getSearch = (value) => {
    setSearch(value);
  };

  // * * * * get instagram search
  const getInstaramhash = () => {
    setIsLoading(true);
    setInstaResults([]);
    axios
      .get(
        "https://www.instagram.com/explore/tags/" +
          search.replace(" ", "") +
          "/?__a=1",
        {
          crossDomain: true,
        }
      )
      .then((res) => {
        const instResults =
          res.data.graphql?.hashtag?.edge_hashtag_to_top_posts?.edges;
        console.log("instResults", instResults);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setInstaResults([]);
      });
  };

  // * * * get Results
  const getResults = () => {
    setIsLoading(true);
    setResult(null);
    axios
      .post(`${apiUrl}/search/${search}`, {
        postLimit: postLimit,
      })
      .then((res) => {
        const searchResults = res.data;
        if (searchResults.success) {
          setResult(searchResults.data);
        } else {
          setResult(null);
        }
        console.log("search results >>>", searchResults);
        setIsFetch(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsFetch(false);
        setIsLoading(false);
        console.log(err);
      });
  };

  // * * * handle Next Page
  const handleNextPage = () => {
    setPostLimit((prevCount) => prevCount + 10);
    setIsLoading(true);
    axios
      .post(`${apiUrl}/search/${search}`, {
        postLimit: postLimit,
      })
      .then((res) => {
        const searchResults = res.data;
        if (searchResults.success) {
          setResult(searchResults.data);
        }
        setIsFetch(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsFetch(false);
        setIsLoading(false);
        console.log(err);
      });
  };

  // saveSearchResults
  const saveSearchResults = () => {
    axios
      .post(`${API_BASE_URL}search/create`, {
        user: user?._id,
        search: search,
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (isFetch) {
      // getInstaramhash();

      getResults();
      if (user) {
        saveSearchResults();
      }
    }
  }, [isFetch]);

  // * * * handleFetch
  const handleFetch = (value) => {
    // console.log("handle", value);
    setIsFetch(value);
  };
  return (
    <div>
      <Helmet>
        {/*<header>*/}
        {/*  <title>Nested Title</title>*/}
        {/*  <meta name="description" content="Nested component" />*/}
        {/*</header>*/}
      </Helmet>
      <Intro
        search={search}
        getSearch={getSearch}
        isLoading={isLoading}
        isFetch={isFetch}
        handleFetch={handleFetch}
      />
      {result && (
        <Results
          search={search}
          result={result}
          handleNextPage={handleNextPage}
          isLoading={isLoading}
          color="purple"
        />
      )}
    </div>
  );
}

export default Home;
